export const WATCHLIST_GOLD = 'WATCHLIST_GOLD'
export const WATCHLIST_STOCK = 'WATCHLIST_STOCK'
export const WATCHLIST_FUND = 'WATCHLIST_FUND'